export const TEMPLATES = {
  columnHeaderIndex: 2,
  rowStartIndex: 6,
  rowEndIndex: 20,
}

export const COMPANY_SHEET_NAME = '01-COMPANY'
export const BRANCH_SHEET_NAME = '02-BRANCH'
export const PRODUCT_SHEET_NAME = '04-PRODUCT_BRANCH'
export const SKU_SHEET_NAME = '03-PRODUCT'

export const COMPANY_HEADER = [
  'Name',
  'TaxID',
  'Email',
  'Phone',
  'Status',
  'Remark',
  'Address',
  'Country',
  'Province ',
  'District ',
  'Sub-district ',
  'Postal Code',
]

export const BRANCH_HEADER = [
  'Company Code',
  'Branch Name',
  'Phone ',
  'Email',
  'Remark',
  'Contact Name',
  'Phone',
  'Location link',
  'Address',
  'Country',
  'Province ',
  'District ',
  'Sub-district ',
  'Postal Code',
]

export const PRODUCT_HEADER = [
  'SKU Code',
  'Serial Number',
  'Date of Purchase',
  'Warranty Type',
  'Maintenance cycle',
  'Maintenance Period',
  'Warranty Cycle ',
  'Warranty Period',
  'Start Date',
  'End Date',
]

export const SKU_HEADER = [
  'SKU Code',
  'SKU Name',
  'Brand',
  'Product Type',
  'Cost Price',
  'Sale Price',
  'Maintenance Cycle',
  'Maintenance Period',
  'Detail',
]
